
(function () {
  function bindGallery(root) {
    const thumbs = Array.from(root.querySelectorAll('[data-media-thumb]'));
    const panels = Array.from(root.querySelectorAll('[data-media-panel]'));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaThumb;

        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.dataset.mediaPanel === id;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function bindQuantity(root) {
    const input = root.querySelector('[data-qty-input]');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');

    if (!input) return;

    minus?.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = Math.max(1, current - 1);
    });

    plus?.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = Math.max(1, current + 1);
    });
  }

  async function refreshVariant(root, changedInput) {
    const selectors = changedInput.closest('.option-value-selectors');
    if (!selectors) return;

    const sectionId = root.dataset.sectionId;
    const checked = Array.from(selectors.querySelectorAll('input[type="radio"]:checked'));
    const optionValues = checked.map((input) => input.dataset.optionValueId).filter(Boolean);

    if (!sectionId || !optionValues.length) return;

    const url = new URL(window.location.href);
    url.searchParams.delete('variant');
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('option_values', optionValues.join(','));

    try {
      root.classList.add('is-loading');

      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Variant refresh failed');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const replacement = doc.querySelector('[data-madeo-product]');

      if (!replacement) throw new Error('Product section missing in response');

      root.replaceWith(replacement);
      initProduct(replacement);

      const variantId = replacement.querySelector('[data-variant-id]')?.value;
      if (variantId) {
        const browserUrl = new URL(window.location.href);
        browserUrl.searchParams.set('variant', variantId);
        browserUrl.searchParams.delete('option_values');
        browserUrl.searchParams.delete('section_id');
        window.history.replaceState({}, '', browserUrl.toString());
      }

      const newInput = replacement.querySelector(`#${CSS.escape(changedInput.id)}`);
      newInput?.focus();
    } catch (error) {
      console.error(error);
      root.classList.remove('is-loading');
    }
  }

  function bindVariants(root) {
    root.querySelectorAll('.option-value-selectors input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => refreshVariant(root, input));
    });
  }

  function initProduct(root) {
    if (!root || root.dataset.productReady === 'true') return;
    root.dataset.productReady = 'true';

    bindGallery(root);
    bindQuantity(root);
    bindVariants(root);
  }

  document.querySelectorAll('[data-madeo-product]').forEach(initProduct);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-madeo-product]').forEach(initProduct);
  });
})();
